import { useState } from 'react';
import { cn, ui } from '../lib/ui';

/**
 * Copy `text` to the clipboard and say so for two seconds (the CheckInCode
 * pattern). `label` names what is copied for screen readers, for example
 * "Copy the TXT record name".
 */
export default function CopyButton({ text, label, className }) {
  const [state, setState] = useState('idle');

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setState('copied');
    } catch {
      setState('failed');
    }
    setTimeout(() => setState('idle'), 2000);
  }

  return (
    <button
      type="button"
      className={cn(ui.btnSecondary, ui.btnSm, 'shrink-0', className)}
      onClick={copy}
      aria-label={label}
      title={label}
    >
      {state === 'copied' ? 'Copied ✓' : state === 'failed' ? 'Select and copy' : 'Copy'}
      <span className="sr-only" aria-live="polite">
        {state === 'copied' ? 'Copied' : ''}
      </span>
    </button>
  );
}
